/* import __COLOCATED_TEMPLATE__ from './sales-tax-settings.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
let SalesTaxSettings = (_class = class SalesTaxSettings extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "sentry", _descriptor, this);
    _initializerDefineProperty(this, "status", _descriptor2, this);
    _initializerDefineProperty(this, "isLoading", _descriptor3, this);
  }
  get formattedTaxEntries() {
    return this.args.taxEntries.map(entry => {
      const isInactive = !entry.enabled;
      return {
        name: entry.name,
        displayValue: isInactive ? '' : `${entry.percentage}%`,
        isInactive
      };
    });
  }
  get isSuccess() {
    return this.status === 'success';
  }
  get isError() {
    return this.status === 'error';
  }
  get showSettings() {
    return this.status === 'settings';
  }
  async handlePrimaryButtonClick() {
    if (!this.args.showResultAfterPrimaryAction) {
      this.args.onPrimaryButtonClick();
      return;
    }
    this.isLoading = true;
    try {
      await this.args.onPrimaryButtonClick();
      this.status = 'success';
    } catch (error) {
      this.sentry.captureException(error);
      this.status = 'error';
    } finally {
      this.isLoading = false;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "status", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'settings';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "handlePrimaryButtonClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handlePrimaryButtonClick"), _class.prototype), _class);
export { SalesTaxSettings as default };